import {Component, Inject, Input} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DialogConfigInterface} from 'appShared/components';

import {AddFeedForm} from 'appEntries/panel/forms/market-data';
import {
    ApiError,
    AuthApiService,
    ExchangeModel,
    NasdaqReportMapsEnum,
    PlatformFrontendInterface,
    PortalInterface,
    SesHelper,
    SesService
} from '@spa/api';
import {MarketDataFeedFormTypesEnum, MarketDataFeedsFormErrorStatesEnum} from 'appEntries/panel/enums';
import {MarketDataFeedsAddMessages} from 'appAssets/messages';
import {AlertsService, CurrencyService} from 'appShared/services';
import {PanelBaseMarketDataFormDialogComponent} from 'appEntries/panel/dialogs/ses/panel-base-market-data-form-dialog.component';
import {Helper, SelectControl} from 'appShared/classes';
import {Subscription} from 'rxjs';
import {AddNewFeedMarketSelector} from 'appAssets/descriptors';

@Component({
    selector: 'app-market-data-add-feed',
    templateUrl: './market-data-add-feed.component.html',
    styleUrls: ['./market-data-add-feed.component.scss']
})
export class MarketDataAddFeedComponent extends PanelBaseMarketDataFormDialogComponent<MarketDataAddFeedComponent> {
    public selectedNasdaqReportMaps: NasdaqReportMapsEnum[];
    @Input() public exchanges: ExchangeModel[];
    @Input() public platformFrontends: PlatformFrontendInterface[];
    @Input() public portals: PortalInterface[];

    public readonly NasdaqReportMapsEnum = NasdaqReportMapsEnum;
    public isNasdaqOrNasdaqUtpSelected: boolean;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            config: DialogConfigInterface,
            exchanges: ExchangeModel[],
            platformFrontends: PlatformFrontendInterface[],
            portals: PortalInterface[],
        },
        private readonly authenticationService: AuthApiService,
        private readonly sesService: SesService,
        protected alertsService: AlertsService,
        protected currencyService: CurrencyService,
        public dialogRef: MatDialogRef<MarketDataAddFeedComponent>,
    ) {
        super(dialogRef, alertsService);
        this.config = data.config;
        this.exchanges = data.exchanges;
        this.platformFrontends = data.platformFrontends;
        this.portals = data.portals;
        this.selectedNasdaqReportMaps = [];
    }


    ngOnInit(): void {
        this.initForm();
        const marketChangeSubscription: Subscription = this.form.formGroup.controls[AddNewFeedMarketSelector]?.valueChanges
        .subscribe(value => {
            const exchangeModel = this.exchanges.find(item => item.id === value);
            this.isNasdaqOrNasdaqUtpSelected = SesHelper.isNasdaqOrNasdaqUTPSelected(exchangeModel);
        });

        this.subscriptions.push(marketChangeSubscription);
    }

    hasL1Change(val: boolean) {
        (this.form as AddFeedForm).hasL1 = val;
    }

    hasL2Change(val: boolean) {
        (this.form as AddFeedForm).hasL2 = val;
    }

    initForm(): void {
        this.form = new AddFeedForm(
            this.authenticationService,
            this.sesService,
            this.currencyService,
            MarketDataFeedFormTypesEnum.All,
            this.exchanges,
            this.platformFrontends,
            this.portals
        );
        this.form.initForm();
    }

    getErrorMessageByApiError(error: ApiError): string {
        if (error.status === MarketDataFeedsFormErrorStatesEnum.CreateMarketDataFeedFailed) {
            return MarketDataFeedsAddMessages.MarketDataFeedCreationFailed.message;
        }

        return MarketDataFeedsAddMessages.UnknownError.message;
    }

    getSuccessFormMessage(): string {
        return MarketDataFeedsAddMessages.MarketDataFeedCreationSucceed.message;
    }

    addReportMap(): void {
        const reportMapControl = this.form.controls[22] as SelectControl;
        this.selectedNasdaqReportMaps.push(reportMapControl.value as NasdaqReportMapsEnum);
        reportMapControl.options = reportMapControl.options.filter(item => item.value !== reportMapControl.value);
    }

    removeReportMap(reportMap: NasdaqReportMapsEnum): void {
        const reportMapControl = this.form.controls[22] as SelectControl;
        this.selectedNasdaqReportMaps = this.selectedNasdaqReportMaps.filter(item => item !== reportMap);
        reportMapControl.options.push({
                label: Helper.textsHelper().getNasdaqReportMapText(reportMap),
                value: reportMap
            },
        );
    }
}
